import { Injectable } from '@angular/core';
import emailjs from 'emailjs-com';

@Injectable({
  providedIn: 'root',
})
export class EmailService {
  constructor() {}

  sendEmail(templateParams: any) {
    debugger;
    emailjs
      .send(
        'service_0rdqalc',
        'template_4wguvib',
        templateParams,
        'Sd8gfUWLC9w4YtLif'
      )
      .then(
        (response) => {
          console.log('Email sent successfully', response);
        },
        (error) => {
          console.error('Error sending email:', error);
        }
      );
  }
}
